__turbopack_context__.v({
  "center": "pUrx9G_center",
  "contentWrapper": "pUrx9G_contentWrapper",
  "fullScreen": "pUrx9G_fullScreen",
  "fullWidth": "pUrx9G_fullWidth",
  "modal": "pUrx9G_modal",
});
